import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Tutorial } from '../types/tutorial';

export function useTutorials(categorySlug?: string, orderBy?: { column: string; ascending?: boolean }) {
  const [tutorials, setTutorials] = useState<Tutorial[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchTutorials() {
      try {
        setLoading(true);
        let query = supabase
          .from('tutorials')
          .select('*')
          .eq('published', true)

        // Apply ordering
        if (orderBy) {
          query = query.order(orderBy.column, { ascending: orderBy.ascending !== false });
        } else {
          query = query.order('published_at', { ascending: false });
        }

        if (categorySlug) {
          query = query.eq('category_slug', categorySlug);
        }

        const { data, error: fetchError } = await query;

        if (fetchError) throw fetchError;
        setTutorials(data || []);
      } catch (err) {
        console.error('Error fetching tutorials:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    fetchTutorials();
  }, [categorySlug, orderBy]);

  return { tutorials, loading, error };
}